import { Component, input, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { cn } from '@shared/utils/class-names';

@Component({
  selector: 'app-mobile-nav',
  standalone: true,
  imports: [TranslocoPipe],
  templateUrl: './mobile-nav.component.html',
})
export class MobileNavComponent {
  readonly isDark = input(false);
  readonly menuRequested = output<void>();

  protected readonly cn = cn;

  protected openMobile(): void {
    this.menuRequested.emit();
  }
}
